import React from 'react';

const ArrowUp = () => (
  <svg
    width="11"
    height="7"
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6L5.5 2L10 6"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ArrowUp;
